import React, {useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import LeftMenu from './components/LeftMenu'; 
import RightContainer from './components/RightContainer'; 
import MetaMaskConnect from './components/MetaMaskConnect';
import NewsFeed from './components/NewsFeed';
import StreamFacts from './components/StreamFacts';
import MainPage from './pages/MainPage'; 
import Simulator from './pages/Simulator'; 
import FearAndGreed from './pages/FearAndGreed'; 
import StrategySettings from './pages/StrategySettings'; 
import News from './pages/News';
import TRViwerPage from './pages/TRViwerPage';
import Indicators from './pages/Indicators';
import TopBuySell from './pages/TopBuySell';
import Wallets from './pages/Wallets';
import Shop from './pages/Shop';
import MySpace from './pages/MySpace';
import Investments from './pages/Investments';
import Temp from './pages/Temp';
import About from './pages/About';
import TRViewFacts from './pages/TRViewFacts';
import Mobile from './pages/Mobile';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import { io } from "socket.io-client";

window.addEventListener('beforeunload', function (event) {
  const user_id = localStorage.getItem('user_id');  

  fetch(`/api/cleanup_session`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 'user_id': user_id })
  });
});

const AppLayout = () => {  
  const { daysLeft, isPremium } = useSelector(state => state.globalData);   

  return (
    <div className="page-container scrollableContainer">
      <div className="layout">
        <div className="header">
          <div className="header-column1">
            { isPremium && 
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={require('./images/crown.png')} alt="crown" style={{ marginRight: '5px', width: '30px' }} />
                  <span style={{ color: '#65ff63', fontSize: '12pt' }}>You are Premium</span><br />
                </div>
                <div style={{ color: daysLeft < 3 ? '#ff4e00' : '#65ff63', fontSize: '11pt' }}>
                  <span>{daysLeft} days left</span>
                </div>
              </>
            }
          </div>
          <div className="header-column2">
            <NewsFeed/>
            <StreamFacts/>
          </div>
          <div className="header-column3">
            <MetaMaskConnect/>
          </div>
        </div>
        <div className="content">
          <div className="sidebar-left">
            <LeftMenu/>
          </div>
          <div className="main-content">          
            <Routes>                    
              <Route path="/" element={<MainPage/>} />
              <Route path="/Simulator" element={<Simulator/>} />
              <Route path="/FearAndGreed" element={<FearAndGreed/>} />
              <Route path="/StrategySettings" element={<StrategySettings/>} />
              <Route path="/News/:idx" element={<News/>} />
              <Route path="/TRViwerPage" element={<TRViwerPage/>} />
              <Route path="/Indicators" element={<Indicators/>} />
              <Route path="/TopBuySell" element={<TopBuySell/>} />
              <Route path="/Shop" element={<Shop/>} />
              <Route path="/Wallets" element={<Wallets/>} />
              <Route path="/MySpace" element={<MySpace/>} />
              <Route path="/Investments" element={<Investments/>} />
              <Route path="/Temp" element={<Temp/>} />             
              <Route path="/About/:idx" element={<About/>} />             
              <Route path="/TRViewFacts" element={<TRViewFacts/>} />             
              <Route path="/Mobile" element={<Mobile/>} />             
            </Routes>                   
          </div>
          <div className="sidebar-right">
            <RightContainer/>
          </div>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  const navigate = useNavigate(); 
  const location = useLocation();

  // Check if the current route is the home route ("/")
  const isHomePage = location.pathname === "/";
  const isAbout = location.pathname === "/About";
  
   // Simple mobile detection using userAgent
   const isMobile = /Mobi|Android/i.test(navigator.userAgent);

   useEffect(() => {
     if (isMobile && location.pathname !== "/Mobile" && location.pathname !== "/About/1") {
       // Redirect to the mobile page if the user is on a mobile device
       navigate("/Mobile");
     }
   }, [isMobile, location, navigate]);

  return (
    <div>
      {isHomePage ? (
        <MainPage />
      ) : isAbout ? (
        <About />
      ) : (
        <AppLayout />
      )}
    </div>
  );
};

// Wrapping App component with Router at the root level
const AppWithRouter = () => (
  <Router>
    <App />
  </Router>
);

export default AppWithRouter;